import { useEffect, useState } from 'react';
import { getAgentTasks } from '../lib/api/agents';
import { agentTasks } from '../mocks/agentDetail';

function useAgentTasks(agentId) {
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    getAgentTasks(agentId)
      .then((data) => {
        if (!cancelled) setTasks(data);
      })
      .catch(() => {
        // No backend yet — mocks are the interim API contract.
        if (!cancelled) setTasks(agentTasks(agentId));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [agentId]);

  return { tasks, isLoading };
}

export default useAgentTasks;
